/**
 * Menu Componenets
 *
 * @file menu.js
 */

import $ from 'jquery';

const menu = (() => {
  // Services Page Project List
  const mobileFooterMenu = () => {
    $(".footer-m-select").each(function(){
      $(this).on("change", function(){
        window.open($(this).val(),"_self");
      })
    });
  };

  const profileLeftMenuBar = () => {
    document.querySelectorAll('.profile-slide').forEach((slide) => {
      const dataWidth = parseFloat(slide.getAttribute('data-width')) || 0;
    
      if (dataWidth > 0.99) {
        slide.classList.add('green'); // %1'in üstündeyse "green" class'ı eklenir.
      } else {
        slide.classList.remove('green'); // %1'in altındaysa "green" class'ı kaldırılır.
      }
    });
  };

  const init = () => {
    mobileFooterMenu();
    profileLeftMenuBar();
  };

  return {
    init,
  };
})();

export default menu;
